import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const GavelIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M2.94457 20.1109H12.3902C12.9097 20.1109 13.3348 20.5359 13.3348 21.0554C13.3348 21.5749 12.9097 22 12.3902 22H2.94457C2.42505 22 2 21.5749 2 21.0554C2 20.5359 2.42505 20.1109 2.94457 20.1109ZM6.00496 7.89764L8.67808 5.22452L20.7024 17.2488C21.4392 17.9856 21.4392 19.1852 20.7024 19.922C19.9656 20.6587 18.766 20.6587 18.0293 19.922L6.00496 7.89764ZM14.0243 2.5514L16.6974 5.22452C17.4342 5.96128 17.4342 7.16088 16.6974 7.89764L15.3562 9.23892L10.0194 3.89268L11.3512 2.56084C12.088 1.81463 13.2876 1.81463 14.0243 2.5514ZM4.67312 9.22947L10.0194 14.5757L8.68752 15.9076C7.95076 16.6443 6.75116 16.6443 6.0144 15.9076L3.34128 13.2344C2.60452 12.4977 2.60452 11.2981 3.34128 10.5613L4.67312 9.22947Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
